import {
  Form,
  Modal,
  Input,
  Select,
  Upload,
  Radio,
  Cascader,
  message,
  Image
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import service from "../../../../@services";
import config from "../../../../@config";
import { getRequestHeader } from "../../../../@utils/request.js";
import StoreProductQuery from '../../components/storeProductQuery'

const { Dragger } = Upload;

const ModalComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => { },
    onOk = () => { },
    jumpType = [],
    modalData = {}
  } = props;

  const [form] = Form.useForm()
  const [linkTypeArr, setLinkTypeArr] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [dynamicForm, setDynamicForm] = useState(null)
  const [fileList, setPictureFileList] = useState([])
  const [imageUrl, setImageUrl] = useState()
  const [isImage, setIsImage] = useState(false)

  // 获取类型
  const getCategoryTree = async () => {
    const cates = await service.mallManagement.getSpecialProductList()
    setCategoryData(cates)
  }
  // 变更上传文件
  const changeFileFn = (val) => {
    setPictureFileList(val)
    if (val.length > 0 && val[0].response) {
      setImageUrl(val[0].response.data)
      setIsImage(false)
    }
  }
  // 上传限制
  const beforeUpload = file => {
    const isJPG = file.type === 'image/jpg'
    const isJPEG = file.type === 'image/jpeg'
    const isPNG = file.type === 'image/png'
    const isGIF = file.type === 'image/gif'
    const isLt5M = file.size / 1024 < 500
    if (!isJPG && !isJPEG && !isPNG && !isGIF) {
      message.error('上传图片只能是 jpg/jpeg/png/gif 格式!');
    }
    if (!isLt5M) {
      message.error('上传图片大小不能超过 500kb!')
    }
    return (isJPG || isJPEG || isPNG || isGIF) && isLt5M ? true : Upload.LIST_IGNORE
  }
  // 变更链接类型
  const changeLinkType = (val) => {
    if (form.getFieldValue().hrefData) {
      form.getFieldValue().hrefData = null
    }
    switch (val) {
      case 'NO':
        setDynamicForm(null)
        break;
      case 'CURRENT':
        setDynamicForm(
          <Form.Item name="hrefData" label="内链跳转" rules={[{ required: true }]}>
            <Input placeholder="请输入内链跳转ID" />
          </Form.Item>
        )
        break;
      case 'LINK':
        setDynamicForm(
          <Form.Item name="hrefData" label="外链链接" rules={[{ required: true }]}>
            <Input placeholder="请输入http或https地址" />
          </Form.Item>
        )
        break;
      case 'ZONE':
        setDynamicForm(
          <Form.Item name="hrefData" label="专区ID" rules={[{ required: true }]}>
            <Input placeholder="请输入专区ID" />
          </Form.Item>
        )
        break;
      case 'CUSTOM':
        setDynamicForm(
          <Form.Item name="hrefData" label="外链链接" rules={[{ required: true }]}>
            <Input placeholder="请输入http或https地址" />
          </Form.Item>
        )
        break;
      case 'CATEGORY':
        setDynamicForm(
          <Form.Item name="hrefData" label="选择分类" rules={[{ required: true }]}>
            <Cascader
              options={categoryData}
              placeholder="请选择"
              fieldNames={{
                label: 'categoryName',
                value: 'categoryCode',
                children: 'children'
              }}
            />
          </Form.Item>
        )
        break;
      case 'PRODUCT':
        setDynamicForm(
          <>
            <Form.Item name="productDetail" rules={[{ required: true, message: '请点击搜索获取商品信息' }]}>
              <StoreProductQuery></StoreProductQuery>
            </Form.Item>
            <Form.Item
              name="name"
              label="商品名称"
              rules={[{ required: true }]}
            >
              <Input style={{ width: 260 }} disabled />
            </Form.Item>
          </>
        )
        break;
      default:
        setDynamicForm(null)
        break;
    }
  }
  // 表单验证
  const validate = (val) => {
    form.validateFields().then(res => {
      if (!val.imageUrl) {
        message.error('图片未找到')
        return
      }
      onOk(val)
    }).catch()
  }
  // 表单提交
  const submitFormVal = () => {
    let temUrl;
    if (!imageUrl) {
      temUrl = modalData.imageUrl
    }
    const submitVal = Object.assign({}, form.getFieldValue(), {
      imageUrl: imageUrl ? imageUrl : temUrl
    })
    validate(submitVal)
  }
  const handlerChange = e => {
    let fieldItem = e[0]
    if (fieldItem.name[0] === 'productDetail') {
      form.setFieldsValue(fieldItem.value)
    }
  }

  useEffect(() => {
    getCategoryTree()
    setLinkTypeArr(jumpType)
  }, [])
  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setIsImage(false)
      setPictureFileList([])
      setDynamicForm(null)
    }
  }, [visible])
  useEffect(() => {
    modalData.url ? setIsImage(true) : setIsImage(false)
    changeLinkType(modalData.hrefType)
    form.setFieldsValue(modalData)
  }, [modalData])

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={submitFormVal}
      cancelText="取消"
      okText="确认"
    >
      <Form
        form={form}
        onFieldsChange={handlerChange}
        labelCol={{ span: 5 }}
        initialValues={{
          status: 1
        }}
      >
        <Form.Item name="id" style={{ display: "none" }}>
          <></>
        </Form.Item>
        <Form.Item
          name="title"
          label="名称"
          rules={[{ required: true, message: "请输入名称" }]}
        >
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item
          name="hrefType"
          label="跳转类型"
          rules={[{ required: true, message: '清选择跳转类型' }]}
        >
          <Select allowClear onChange={changeLinkType}>
            {linkTypeArr.map(item => (
              <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        {dynamicForm}
        <Form.Item
          label="广告图片"
          valuePropName="fileList"
          required
        >
          <Dragger
            action={config.BASE_API + "/common/uploadPictureFile"}
            maxCount={1}
            headers={getRequestHeader()}
            beforeUpload={beforeUpload}
            listType="picture-card"
            fileList={fileList}
            onChange={({ fileList }) => changeFileFn(fileList)}
          >
            {isImage ? <Image preview={false} src={modalData.url} /> : (
              <>
                <p className="ant-upload-drag-icon">
                  <UploadOutlined style={{ color: '#ccc' }} />
                </p>
                <p className="ant-upload-hint">
                  将文件拖到此处，或<span style={{ color: '#33ccff' }}>点击上传</span>
                </p>
                <p className="ant-upload-hint">
                  只能上传 jpg/png 文件，分辨率300*400，且不超过 500kb
                </p>
              </>
            )}
          </Dragger>
        </Form.Item>
        <Form.Item
          name="sort"
          label="排序"
          rules={[{ required: true, message: "请输入排序" }]}
        >
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item
          name="status"
          label="状态"
          rules={[{ required: true }]}
        >
          <Radio.Group>
            <Radio value={1}>启用</Radio>
            <Radio value={0}>停用</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalComponent;
